import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Application } from '@app/interfaces/lm/application';
import { TimelineComponent } from '@app/shared/components/timeline/timeline.component';
import { EventInput } from '@fullcalendar/core';
import { ApplicationService } from '@services/lm/application.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-application-detail',
    templateUrl: './application-detail.component.html',
    styleUrls: ['./application-detail.component.less'],
})
export class ApplicationDetailComponent {
    @ViewChild('calendar') calendarEle!: TimelineComponent;
    @Output() success = new EventEmitter();

    isVisible = false;
    detail: Application = {} as Application;
    resources: EventInput[] = [];
    events: EventInput[] = [];

    constructor(private message: NzMessageService, private modal: NzModalService, private applicationService: ApplicationService) {
    }

    open(row: Application): void {
        console.log('detail', row);
        this.isVisible = true;
        this.detail = {
            ...row,
        };
        this.initCalendar();
    }

    close(): void {
        this.isVisible = false;
        console.log('close', this.isVisible);
    }

    initCalendar(): void {
        const {
            startDate,
            endDate,
            testerName,
            testerId,
            projectName,
            conflict
        } = this.detail;
        if (!startDate || !endDate) {
            return;
        }
        const range = {
            startDate,
            endDate,
        };
        const resources: EventInput[] = [];
        const events: EventInput[] = [];
        if (conflict?.length > 0) {
            conflict.forEach(item => {
                resources.push({
                    id: item.id.toString(),
                    title: item.name,
                });
                events.push(...item.range.map(rangeItem => {
                    return {
                        resourceId: String(item.id),
                        start: rangeItem.from,
                        end: rangeItem.to,
                        backgroundColor: rangeItem.conflict ?  '#f5c3b7' : '#DAE8FC',
                        borderColor: rangeItem.conflict ?  '#ff896f' : '#6C8EBF',
                        editable: false,
                        resourceEditable: false
                    };
                }));
            });
            this.resources = [...resources];
            this.events = [...events];
        }
        console.log('resources', this.resources, this.events);
    }

    handleShare(): void {
        console.log('handleShare');
        this.modal.confirm({
            nzTitle: 'You will share this conflict !',
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: async () => {
                console.log('OK');
                await this.handleChange('share');
                this.message.success('Shared successfully');
            },
        });
    }

    handleApprove(): void {
        console.log('handleApprove');
        this.modal.confirm({
            nzTitle: 'You will approve this conflict !',
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: async () => {
                console.log('OK');
                await this.handleChange('approved');
                this.message.success('Approved successfully');
            },
        });
    }

    handleReject(): void {
        console.log('handleReject');
        this.modal.confirm({
            nzTitle: 'You will reject this conflict !',
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: async () => {
                console.log('OK');
                await this.handleChange('rejected');
                this.message.success('Rejected successfully');
            },
        });
    }

    async handleChange(action: string): Promise<void> {
        console.log('handleChange', action, this.detail);
        const id = this.detail?.id;
        if (id) {
            const data = {
                id,
                status: action,
            };
            await this.applicationService.changeStatus(data);
            this.close();
            this.success.emit();
        }
    }
}
